import { AxiosResponse } from 'axios';
import { SET_ATTENDANCE_SCHEDULES, SET_ATTENDANCE_SCHEDULE, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_ATTENDANCE_SCHEDULE_ISLOADING,
  DELETE_ATTENDANCE_SCHEDULE,
  EDIT_ATTENDANCE_SCHEDULE,
  GET_ATTENDANCE_SCHEDULES,
  GET_ATTENDANCE_SCHEDULE,
  REGISTER_ATTENDANCE_SCHEDULE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import AttendanceSchedule from '@/services/attendance_schedule';
import { Module } from 'vuex';
import { EditAttendanceSchedule, RegisterAttendanceSchedule, GetAttendanceSchedule } from '@/dtos/attendance_schedule.dto';

const attendanceSchedule: Module<any, {}> = {
  state: {
    attendanceSchedule: {
      data: null,
      isLoading: false,
    },
    attendanceSchedules: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    attendanceSchedule: (state: { attendanceSchedule: any }) => state.attendanceSchedule,
    attendanceSchedules: (state: { attendanceSchedules: any }) => state.attendanceSchedules,
  },
  mutations: {
    [SET_ATTENDANCE_SCHEDULE]: (
      state: { attendanceSchedule: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.attendanceSchedule.data = payload.data) : null,
        (state.attendanceSchedule.isLoading = payload.isLoading);
    },
    [SET_ATTENDANCE_SCHEDULES]: (
      state: { attendanceSchedules: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.attendanceSchedules.data = payload.data) : null,
        (state.attendanceSchedules.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_ATTENDANCE_SCHEDULE]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_SCHEDULE, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceSchedule.registerAttendanceSchedule(
        payload as RegisterAttendanceSchedule
      );

      if (result) {
        if (result.data.status) {
          commit(SET_ATTENDANCE_SCHEDULE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SCHEDULE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SCHEDULE, { isLoading: false });
        return false;
      }
    },
    [GET_ATTENDANCE_SCHEDULES]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_SCHEDULES, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceSchedule.getAttendanceSchedules(
        payload as GetAttendanceSchedule
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_SCHEDULES, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SCHEDULES, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SCHEDULES, { isLoading: false });
        return false;
      }
    },
    [GET_ATTENDANCE_SCHEDULE]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_SCHEDULE, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceSchedule.getAttendanceSchedules(
        payload as GetAttendanceSchedule
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_SCHEDULE, { data: result.data.data[0], isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SCHEDULE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SCHEDULE, { isLoading: false });
        return false;
      }
    },
    [EDIT_ATTENDANCE_SCHEDULE]: async ({ commit }: any, payload: any) => {
      commit(SET_ATTENDANCE_SCHEDULE, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceSchedule.editAttendanceSchedule(
        payload as EditAttendanceSchedule
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_SCHEDULE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SCHEDULE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SCHEDULE, { isLoading: false });
        return false;
      }
    },
    [DELETE_ATTENDANCE_SCHEDULE]: async ({ commit }: any, payload: string) => {
      commit(SET_ATTENDANCE_SCHEDULE, { data: null, isLoading: true });

      const result: AxiosResponse = await AttendanceSchedule.deleteAttendanceSchedule(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_ATTENDANCE_SCHEDULE, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_ATTENDANCE_SCHEDULE, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_ATTENDANCE_SCHEDULE, { isLoading: false });
        return false;
      }
    },
    [CLEAR_ATTENDANCE_SCHEDULE_ISLOADING]: ({ commit }) => {
      commit(SET_ATTENDANCE_SCHEDULE, { isLoading: false });
      commit(SET_ATTENDANCE_SCHEDULES, { isLoading: false });
    },
  },
};

export default attendanceSchedule;
